import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddPlanzoneVirtualResourceNotificationState = createStateReducer(
  initialState,
  {
    [events.addPlanzoneVirtualResourceSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneVirtualResource",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addPlanzoneVirtualResourceFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addPlanzoneVirtualResource",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddPlanzoneVirtualResourceNotificationState };
